"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const Pagination_1 = tslib_1.__importDefault(require("@mui/material/Pagination"));
const use_context_selector_1 = require("use-context-selector");
const styled_1 = tslib_1.__importStar(require("@eduzz/houston-styles/styled"));
const Select_1 = tslib_1.__importDefault(require("../../Forms/Select"));
const Text_1 = tslib_1.__importDefault(require("../../Forms/Text"));
const Column_1 = tslib_1.__importDefault(require("../../Grid/Column"));
const Container_1 = tslib_1.__importDefault(require("../../Grid/Container"));
const Row_1 = tslib_1.__importDefault(require("../../Grid/Row"));
const Typography_1 = tslib_1.__importDefault(require("../../Typography"));
const context_1 = tslib_1.__importDefault(require("../context"));
const Pagination = React.memo(({ page, optionsPerPage: optionsPerPageProp, onChangePerPage, onChangePage, total, perPage, labelGoToPage, labelItensPerPage, className }) => {
    const loading = (0, use_context_selector_1.useContextSelector)(context_1.default, context => context.loading);
    const [pageInput, setPageInput] = React.useState(page === null || page === void 0 ? void 0 : page.toString());
    const optionsPerPage = React.useMemo(() => {
        if (optionsPerPageProp === false) {
            return null;
        }
        if (typeof optionsPerPageProp === 'string') {
            return optionsPerPageProp.split(',').map(value => ({ label: value, value: Number(value) }));
        }
        return (optionsPerPageProp !== null && optionsPerPageProp !== void 0 ? optionsPerPageProp : [5, 10, 25, 50]).map(value => ({ label: String(value), value }));
    }, [optionsPerPageProp]);
    const handlePageInputChange = React.useCallback((valueOrEvent, event) => {
        var _a;
        let enterPressed = false;
        let value = '';
        if (typeof valueOrEvent === 'object') {
            event = valueOrEvent;
            enterPressed = ((_a = valueOrEvent.key) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'enter';
            value = valueOrEvent.target.value;
        }
        else {
            value = valueOrEvent;
        }
        setPageInput(value);
        if (event.type === 'change' || (event.type === 'keyup' && !enterPressed)) {
            return;
        }
        let currentPage = Math.floor(Number(value));
        const maxPage = Math.ceil(total / perPage);
        if (!currentPage) {
            currentPage = 1;
        }
        if (currentPage > maxPage) {
            currentPage = maxPage;
        }
        if (currentPage != Number(value)) {
            setPageInput(currentPage.toString());
        }
        if (currentPage === page) {
            return;
        }
        onChangePage(currentPage);
    }, [onChangePage, page, perPage, total]);
    const handleChangePerPage = React.useCallback((value) => onChangePerPage(Number(value)), [onChangePerPage]);
    const handleChangePage = React.useCallback((e, page) => onChangePage(page), [onChangePage]);
    React.useEffect(() => {
        const timeout = setTimeout(() => setPageInput(page === null || page === void 0 ? void 0 : page.toString()), 500);
        return () => clearTimeout(timeout);
    }, [page]);
    return ((0, jsx_runtime_1.jsx)("tfoot", Object.assign({ className: className }, { children: (0, jsx_runtime_1.jsx)("tr", { children: (0, jsx_runtime_1.jsx)("td", Object.assign({ colSpan: 1000, className: '__td' }, { children: (0, jsx_runtime_1.jsx)(Container_1.default, Object.assign({ layout: 'fluid' }, { children: (0, jsx_runtime_1.jsxs)(Row_1.default, { children: [(0, jsx_runtime_1.jsx)(Column_1.default, Object.assign({ xs: 12, sm: 'auto' }, { children: (0, jsx_runtime_1.jsxs)(Row_1.default, Object.assign({ justifyContent: 'center' }, { children: [(0, jsx_runtime_1.jsxs)(Column_1.default, Object.assign({ xs: 'auto', className: '__perPage' }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ size: 'xxs', weight: 'semibold' }, { children: labelItensPerPage !== null && labelItensPerPage !== void 0 ? labelItensPerPage : 'Itens por página:' })), (0, jsx_runtime_1.jsx)(Select_1.default, { disabled: loading, size: 'small', margin: 'none', options: optionsPerPage, value: perPage, onChange: handleChangePerPage })] })), (0, jsx_runtime_1.jsxs)(Column_1.default, Object.assign({ xs: 'auto', className: '__labels' }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ size: 'xxs', weight: 'semibold' }, { children: labelGoToPage !== null && labelGoToPage !== void 0 ? labelGoToPage : 'Ir para:' })), (0, jsx_runtime_1.jsx)(Text_1.default, { margin: 'none', size: 'small', disabled: loading, value: pageInput, className: '__input', onChange: handlePageInputChange, onKeyUp: handlePageInputChange, onBlur: handlePageInputChange })] }))] })) })), (0, jsx_runtime_1.jsx)(Column_1.default, Object.assign({ xs: 12, sm: true }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: '__pages' }, { children: (0, jsx_runtime_1.jsx)(Pagination_1.default, { count: Math.ceil(total / perPage), page: page !== null && page !== void 0 ? page : 1, disabled: loading, shape: 'rounded', size: 'medium', onChange: handleChangePage }) })) }))] }) })) })) }) })));
});
exports.default = (0, styled_1.default)(Pagination) `
  & > tr {
    & .__td {
      padding: 12px 0;
    }

    .__perPage {
      width: 240px;
      display: inline-flex;
      align-items: center;

      & > p {
        white-space: nowrap;
        margin-right: ${({ theme }) => theme.spacing.nano};
        color: ${({ theme }) => theme.neutralColor.low.dark};
      }
    }

    .__labels {
      display: inline-flex;
      align-items: center;

      & > p {
        white-space: nowrap;
        margin-right: ${({ theme }) => theme.spacing.nano};
        color: ${({ theme }) => theme.neutralColor.low.dark};
      }

      ${styled_1.breakpoints.down('sm')} {
        display: none;
      }
    }

    .__input {
      max-width: 50px;
    }

    .__pages {
      display: flex;
      justify-content: flex-end;
      height: 100%;
      align-items: center;

      ${styled_1.breakpoints.down('sm')} {
        margin-top: ${({ theme }) => theme.spacing.nano};
        justify-content: center;
      }
    }
  }
`;
